import React, { Component, createContext, useContext } from 'react'
import { get, patch } from 'api'

const InsightsContext = createContext()
InsightsContext.displayName = 'Insights'

export default class InsightsProvider extends Component {
    constructor(props) {
        super(props)

        this.state = {
            insights: [],
            excludedUserCount: 0,
            excludedUsers: [],
            filter: props?.filter ?? {},

            fetchInsights: this.fetch,
            fetchExcludedUsers: this.fetchExcludedUsers,
            includeUser: this.includeUser,

            hasFetched: false,
            hasFetchedExcludedUsers: false,
            fetching: false
        }
    }

    componentDidMount() {
        const { fetchOnMount = true } = this.props
        !!fetchOnMount && this.fetch()
    }

    fetch = async () => {
        const { corporation = false } = this.props

        this.setState({ fetching: true })

        const { ok, response } = await get({
            path: corporation ?
                '/organization/subsidiaries/instruments' :
                '/insights/instruments',
            params: this.state.filter
        })

        this.setState({
            ...((ok && response) ? {
                insights: response.items,
                excludedUserCount: response.meta?.excludedUserCount ?? 0
            } : null),
            hasFetched: true
        })
    }

    fetchExcludedUsers = async () => {
        const { ok, response } = await get({
            path: '/insights/excluded'
        })

        this.setState({
            excludedUsers: (ok && response) ?
                response.items :
                [],
            hasFetchedExcludedUsers: true
        })
    }

    includeUser = async id => {
        const { ok, response } = await patch({
            path: `/users/${id}`,
            body: { excludeFromInsights: false }
        })

        if(ok) {
            this.setState(({ excludedUsers, excludedUserCount }) => ({
                excludedUsers: excludedUsers.filter(user => user.id !== id),
                excludedUserCount: excludedUserCount - 1
            }))
        }

        return { ok, response }
    }

    render() {
        const { children = null } = this.props

        return (
            <InsightsContext.Provider value={this.state}>
                {(typeof children === 'function') && children(this.state)}
                {(typeof children !== 'function') && children}
            </InsightsContext.Provider>
        )
    }
}

export const useInsights = () => useContext(InsightsContext)